import { CDS } from "design-system";
import type { PreviewAction } from "../types";

interface Props {
  action: PreviewAction;
}

export default function PreviewActionTypeIcon({ action }: Props) {
  return (
    <CDS.ActionTypeTag.IconBadgeWithMeetingType
      actionType={action.actionType}
      meetingType={action.actionType === "meeting" ? action.meetingType : undefined}
      size="sm"
    />
  );
}
